import { render } from "./MainSection.vue?vue&type=template&id=ca38fbf2&scoped=true"
const script = {}

import "./MainSection.vue?vue&type=style&index=0&id=ca38fbf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca38fbf2"]])

export default __exports__